import { PublicClientApplication } from "@azure/msal-browser";
import { Config } from "./config";

export const msalInstance = new PublicClientApplication(Config.current().authConfig.msalConfig);
